export default {
  List: {
    Title: "Vị trí tài sản",
    SearchLocation: "Tìm kiếm vị trí tài sản",
    AddButton: "Thêm mới",
    LocationCode: "Mã vị trí tài sản",
    LocationName: "Tên vị trí tài sản",
    OrganizationUnitName: "Đơn vị quản lý",
    Description: "Ghi chú",
    WarningWhenDeleteParentLocation:
      "Vị trí này đã có phát sinh vị trí chi tiết. Bạn không thể xóa.",
  },
  Detail: {
    ParentLocation: "Thuộc",
    Add: "Thêm mới vị trí tài sản",
    Edit: "Sửa vị trí tài sản",
    WarningWhenChooseChildItem:
      "Bạn không thể chuyển vị trí tài sản cấp cao vào là con của vị trí tài sản cấp nhỏ hơn.",
    WarningWhenInactiveParentLocation:
      "Khi ngừng theo dõi vị trí tài sản cấp cha, hệ thống sẽ tự động ngừng theo dõi tất cả các vị trí tài sản cấp con của nó. Bạn có muốn tiếp tục thực hiện không?",
    WarningWhenInactiveLocationIsUsing:
      "Vị trí tài sản này đang được sử dụng trong danh sách tài sản. Bạn có chắc chắn muốn ngừng theo dõi Vị trí tài sản này không?",
    WarningWhenActiveParentLocation:
      "Bạn có muốn bỏ tích Ngừng theo dõi cho tất cả các Vị trí tài sản cấp con không?",
    WarningSelectSeftBecomeParent:
      "Bạn không thể chọn vị trí tài sản <{0}> vì đó chính là vị trí tài sản đang sửa <{1}>. Vui lòng kiểm tra lại!",
    WarningWhenHasRiseWithInactive:
      "Vị trí tài sản <{0}> (hoặc các vị trí tài sản cấp con của vị trí tài sản <{0}>) đang được sử dụng trong danh sách tài sản. Bạn có chắc chắn muốn ngừng theo dõi không?",
    WarningWhenParentHasRise:
      "Vị trí tài sản <{0}> đã có phát sinh tài sản. Tất cả tài sản có vị trí tài sản <{1}> sẽ được chuyển sang vị trí tài sản <{2}>. Bạn có muốn tiếp tục thực hiện không?",
    WarningWhenChildActive:
      "Vị trí tài sản cha đang ở trạng thái <Ngừng theo dõi>. Bạn không thể thiết lập trạng thái <theo dõi> cho vị trí tài sản con.",
  },
};
